/*eslint-disable*/
import React, { useState, useEffect } from "react";

// reactstrap components
import {
    Carousel,
    CarouselItem,
    CarouselIndicators,
    Modal
} from "reactstrap";

// core components
import styled from 'styled-components';

const ImageContainer = styled.div`
    padding: 0;
    margin: 0;
    :hover {
        cursor: pointer;
    }
`;

function CustomCarousel({ style, carouselItems }) {

    // carousel states and functions
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);
    const onExiting = () => {
        setAnimating(true);
    };
    const onExited = () => {
        setAnimating(false);
    };
    const next = () => {
        if (animating) return;
        const nextIndex =
            activeIndex === carouselItems.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };
    const previous = () => {
        if (animating) return;
        const nextIndex =
            activeIndex === 0 ? carouselItems.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };
    const goToIndex = (newIndex) => {
        if (animating) return;
        setActiveIndex(newIndex);
    };

    const [classic, setClassic] = useState(false);

    useEffect(() => {
        if (carouselItems.length === 1) {
            setActiveIndex(0)
        }
    }, [carouselItems.length])

    return (
        <>
            <Carousel
                activeIndex={activeIndex}
                next={next}
                previous={previous}
            >
                <CarouselIndicators
                    items={carouselItems}
                    activeIndex={activeIndex}
                    onClickHandler={goToIndex}
                />
                {
                    carouselItems.map((item) => {
                        return (
                            <CarouselItem
                                onExiting={onExiting}
                                onExited={onExited}
                                key={item.src}
                                className="flex-centered"
                            >
                                <ImageContainer>
                                    <img src={item.src}
                                        alt={item.altText}
                                        style={style}
                                        onClick={() => setClassic(true)}
                                    />
                                </ImageContainer>
                            </CarouselItem>
                        );
                    })}
                <a
                    className="left carousel-control carousel-control-prev"
                    data-slide="prev"
                    href="#pablo"
                    onClick={(e) => {
                        e.preventDefault();
                        previous();
                    }}
                    role="button"
                >
                    <span className="fa fa-angle-left" />
                    <span className="sr-only">Previous</span>
                </a>
                <a
                    className="right carousel-control carousel-control-next"
                    data-slide="next"
                    href="#pablo"
                    onClick={(e) => {
                        e.preventDefault();
                        next();
                    }}
                    role="button"
                >
                    <span className="fa fa-angle-right" />
                    <span className="sr-only">Next</span>
                </a>
            </Carousel>
            {/* modals */}
            <Modal
                isOpen={classic}
                toggle={() => setClassic(false)}
                style={{ minWidth: "100vw", height: "auto" }}
            >
                <div className="page-carousel">
                    <Carousel
                        activeIndex={activeIndex}
                        next={next}
                        previous={previous}
                    >
                        <CarouselIndicators
                            items={carouselItems}
                            activeIndex={activeIndex}
                            onClickHandler={goToIndex}
                        />
                        {carouselItems.map((item) => {
                            return (
                                <CarouselItem
                                    onExiting={onExiting}
                                    onExited={onExited}
                                    key={item.src}

                                >
                                    <ImageContainer>
                                        <img
                                            src={item.src}
                                            alt={item.altText}
                                            onClick={() => setClassic(false)}
                                        />
                                    </ImageContainer>
                                </CarouselItem>
                            );
                        })}
                        <a
                            className="left carousel-control carousel-control-prev"
                            data-slide="prev"
                            href="#pablo"
                            onClick={(e) => {
                                e.preventDefault();
                                previous();
                            }}
                            role="button"
                        >
                            <span className="fa fa-angle-left" />
                            <span className="sr-only">Previous</span>
                        </a>
                        <a
                            className="right carousel-control carousel-control-next"
                            data-slide="next"
                            href="#pablo"
                            onClick={(e) => {
                                e.preventDefault();
                                next();
                            }}
                            role="button"
                        >
                            <span className="fa fa-angle-right" />
                            <span className="sr-only">Next</span>
                        </a>
                    </Carousel>
                </div>
            </Modal>
        </>
    );
}

export default CustomCarousel;
